export default class Accordions {
	constructor() {
		this.headers = document.querySelectorAll('.accordion-header')

		if (!this.headers.length) return

		this.abortController = new AbortController()
		this.#init()
	}

	#init() {
		const { signal } = this.abortController

		this.headers.forEach(header => {
			const isActive = header.classList.contains('active')
			const accordionContent = header.nextElementSibling

			if (accordionContent) {
				accordionContent.style.maxHeight = isActive ? accordionContent.scrollHeight + 'px' : 0
			}

			header.addEventListener(
				'click',
				() => {
					header.classList.toggle('active')
					const content = header.nextElementSibling
					if (!content) return

					if (header.classList.contains('active')) {
						content.style.maxHeight = content.scrollHeight + 'px'
					} else {
						content.style.maxHeight = 0
					}
				},
				{ signal }
			)
		})
	}

	destroy() {
		this.abortController?.abort()
	}
}
